export const characteristicColClass = 'col-span-5';
export const scoreColClass = 'col-span-1';
export const progressColClass = 'col-span-4';
export const importanceColClass = 'col-span-2';
